import * as $ from "jquery";
import "slick-carousel";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: "body",
    ui: {
        facModal: "#find-a-center-modal",
        select: ".js-tab-select",
        mapRadiusSelect: ".js-map-radius-select",
        locationDetailsAccordion: ".js-location-details-accordion",
        facSelects: ".js-fac-select",
        locationListAccordion: ".js-fac-location-list-item",
        addChildButton: ".js-add-child-btn",
        removeChildButton: ".js-remove-birthday-btn",
        savedInputTemplate: ".js-saved-birthday-input",
        childBirthdayForm: ".js-form-group-birthday",
        monthSelect: ".js-month-select",
        daySelect: ".js-day-select",
        timeSelect: ".js-time-select",
        testData: "#test-data",
        form: ".js-schedule-a-visit-form",
        birthdayInputs: ".js-birthday-input-field-wrap .form-control",
        scheduleVisitSelectMonth: "select.js-schedule-visit-select.js-month-select",
        scheduleVisitSelectDay: "select.js-schedule-visit-select.js-day-select",
        scheduleVisitSelectsAll: "select.js-schedule-visit-select",
        birthdayInputMonth: ".js-month-input",
        birthdayInputDay: ".js-day-input",
        birthdayInputYear: ".js-year-input"
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{

    _MAX_CHILDREN_FORM_FIELDS_ = 6
    _CHILDREN_FORM_FIELDS_ = 1
    _JSON_

    static readonly CLOSE_MODAL_WIDTH = 992; // max viewport threshold width for modal

    constructor() {
        super();
    }

    // --------------------------------
    // events
    // --------------------------------

    @on("hide.bs.select @ui.facSelects")
    onCloseCustomBootstrapSelect(JQueryEventObject: any) {
        // ** trigger validation for bootstrap-selects
        // 
        // since these use a slightly different structure and triggering
        // system, need to use bootstrap-select methods to trigger
        // validator messages when you click off of them
        // **

        // console.log("select just closed");
        $(JQueryEventObject.currentTarget).trigger("focusout");
    }

    @on("change @ui.scheduleVisitSelectMonth")
    onChangeScheduleVisitSelectMonth(JQueryEventObject: any) {

        // ** SCHEDULE VISIT DATA OVERVIEW
        // ===============================
        // month and time <select>s are populated via back-end
        // day is populated via AJAX call, depending on selected month

        const $monthSelect = $(JQueryEventObject.currentTarget); // get month <select>
        this.manageMonthSelect($monthSelect);
    }

    @on("keyup @ui.birthdayInputMonth")
    onKeyupBirthdayMonthInput(JQueryEventObject: any) {
        const $currentInput = $(JQueryEventObject.currentTarget);
        const currentKey = JQueryEventObject.key;
        const nextInputClassName = ".js-day-input";

        this.gotoNextInput($currentInput, currentKey, nextInputClassName);
    }

    @on("keyup @ui.birthdayInputDay")
    onKeyupBirthdayDayInput(JQueryEventObject: any) {
        const $currentInput = $(JQueryEventObject.currentTarget);
        const currentKey = JQueryEventObject.key;
        const nextInputClassName = ".js-year-input";

        this.gotoNextInput($currentInput, currentKey, nextInputClassName);
    }

    @on("click @ui.addChildButton")
    onAddChildButtonClick(ev) {
        // get previous birthday form field
        let prev = $(ev.currentTarget).prev();
        let day = prev.find(".js-day-input").val();
        let month = prev.find(".js-month-input").val();
        let year = prev.find(".js-year-input").val();

        let template = _.template(this.ui.savedInputTemplate.html());
        let clone = prev.clone();

        // variables to pass in to templates
        let custom_error_message = "Please enter a valid date as mm / dd / yyyy";
        let input_id = "child-birthday";

        if (this._CHILDREN_FORM_FIELDS_ < this._MAX_CHILDREN_FORM_FIELDS_) {
            this._CHILDREN_FORM_FIELDS_++;
            this.ui.addChildButton.before(template({ custom_error_message, input_id }));
            this.bindUIElements();
            this.ui.childBirthdayForm.addClass("has-margin-right");

            this.triggerFormValidator();
        }

        if (this._CHILDREN_FORM_FIELDS_ === this._MAX_CHILDREN_FORM_FIELDS_) {
            this.ui.addChildButton.addClass("is-display-none");
        }

    }

    @on("click @ui.removeChildButton")
    onRemoveChildButtonClick(ev) {
        this._CHILDREN_FORM_FIELDS_--;
        if (this._CHILDREN_FORM_FIELDS_ === 1) {
            this.ui.childBirthdayForm.removeClass("has-margin-right");
        }

        if (this.ui.addChildButton.hasClass("is-display-none")) {
            this.ui.addChildButton.removeClass("is-display-none");
        }

        $(ev.currentTarget).closest(".js-extra-birthday-input-field").remove();
    }

    @on("change @ui.monthSelect")
    onMonthSelectChange(ev) {
        // let days = this._JSON_.data[$(ev.currentTarget).val()]; // UNUSED?
        this.onScheduleVisitSelectChange($(ev.currentTarget), this.ui.daySelect);
    }

    @on("change @ui.daySelect")
    onDaySelectChange(ev) {
        this.onScheduleVisitSelectChange($(ev.currentTarget), this.ui.timeSelect);
    }

    // need to call checkBirthdayInputsForErrors function on both input 
    // and blur to override bootstrap-validator functionality
    @on("input @ui.birthdayInputs")
    onInputChange(ev) {
        this.checkBirthdayInputsforErrors(ev);
    }

    @on("blur @ui.birthdayInputs")
    onBlurBirthdayInput(ev) {
        this.checkBirthdayInputsforErrors(ev);
    }

    // used for schedule a visit month and day <selects>
    onScheduleVisitSelectChange(currentTarget: any, elm: any) {
        let isDefault = currentTarget.find(":selected").hasClass("is-default");
        if (!isDefault) {
            elm.prop("disabled", false);
            elm.closest(".form-group").removeClass("is-disabled");
            elm.selectpicker("refresh");
        } else {
            elm.prop("disabled", true);
            elm.closest(".form-group").addClass("is-disabled");
            elm.val(elm.find("option:first").val());
            elm.selectpicker("refresh");

            if (currentTarget.hasClass("js-month-select")) {
                this.ui.timeSelect.prop("disabled", true);
                this.ui.timeSelect.closest(".form-group").addClass("is-disabled");
                this.ui.timeSelect.val(this.ui.timeSelect.find("option:first").val());
                this.ui.timeSelect.selectpicker("refresh");
            }
        }
    }

    // --------------------------------
    // functions
    // --------------------------------

    onRender() {
        console.log("find a center viewcontroller rendered");
        this.init();
        this.addEventListeners();
    }

    init() {
        // this.buildDateSelects(); // ** DEPRECATED: populating date options via back-end
        this.initializeSelect();
    }

    addEventListeners() {
        // add a class to html that prevents scrolling
        this.ui.facModal.on("show.bs.modal", () => {
            $("html").addClass("modal-is-showing");
        });

        this.ui.facModal.on("hidden.bs.modal", () => {
            $("html").removeClass("modal-is-showing");
        });

        // find a center modal does not exist on narrow/mobile view.
        // if user opens on wide view, then scales down width,
        // close modal at `CLOSE_MODAL_WIDTH`. throttle every 500 ms for efficiency.
        $(window).on("resize", _.throttle(() => {
            this.manageModalBasedOnWindowWidth();
        }, 500));

        this.ui.locationDetailsAccordion.on("click", this.onLocationDetailsAccordionClick);
        this.ui.locationListAccordion.on("click", this.onLocationListAccordion);
    }

    initializeSelect() {
        this.ui.select.selectpicker({
            "width": "100%"
        });

        this.ui.mapRadiusSelect.selectpicker({
            "width": "100px"
        });

        this.ui.facSelects.selectpicker({
            "width": "100%",
            "noneSelectedText": ""
        });
    }

    gotoNextInput($currentInput: any, currentKey:string, nextInputClassName: string) {
        // ONLY use for month and day inputs
        const currentNumChars = $currentInput.val().length;
        const maxCharCount = parseInt($currentInput.attr("maxlength")); // convert string to integer

        // if maxlength reached on input and not deleting...
        if (currentNumChars === maxCharCount) {
            // make sure it doesn't proceed if user is navigating within existing values
            if (!((currentKey === "Backspace") || (currentKey === "ArrowLeft") || (currentKey ==="ArrowRight"))) {
                // month -> day -> year
                $currentInput.next(nextInputClassName).focus();
            }
        }
    }

    manageModalBasedOnWindowWidth() {
        let currentWindowWidth = $(window).width();

        if (currentWindowWidth < ViewController.CLOSE_MODAL_WIDTH) {

            // close modal if viewport is below threshold width
            (<any>this.ui.facModal).modal("hide");

            // remove scroll lock class
            $("html").removeClass("modal-is-showing");
        }
    }

    // ** DEPRECATED: we are now populating date options partially via back-end instead
    // buildDateSelects() {
    //     if (this.ui.testData.length) {
    //         this._JSON_ = JSON.parse(this.ui.testData.html());
    //         let months = Object.keys(this._JSON_.data);
    //         let that = this;

    //         _.each(months, (item) => {
    //             let elm = $("<option></option>").text(item);
    //             that.ui.monthSelect.append(elm);
    //         });
    //     }
    // }

    onLocationDetailsAccordionClick(ev) {
        $(ev.currentTarget).toggleClass("is-active");
        $(ev.currentTarget).find(".bhc-icon-arrow-down-1").toggleClass("is-active");
        $(ev.currentTarget).find(".js-detail-accordion-text").slideToggle();
    }

    onLocationListAccordion(ev) {
        $(ev.currentTarget).toggleClass("is-active");
        $(ev.currentTarget).find(".bhc-icon-arrow-forward").toggleClass("is-active");
        $(ev.currentTarget).find(".js-fac-locations").slideToggle();
    }

    checkBirthdayInputsforErrors(ev) {
        let parent = $(ev.currentTarget).closest(".js-form-group-birthday");
        let inputs = parent.find("input");
        let $inputs = $(inputs);
        let errorMessage = parent.find(".list-unstyled");

        let matchesRequiredPattern = _.every(inputs, (input) => {
            let $input = $(input);
            let pattern = $input.attr("pattern");
            let regex = new RegExp(pattern);

            return regex.test($input.val());
        });

        // ** date check - leap year and num days in specific months
        //    ======================================================

        //    in addition to numerical pattern checks, check each birthday
        //    input GROUP for days in month, leap year, etc

        //    ** NOTE: currently uses combination of REDUNDANT pattern recognition
        //    in html data-attributes, AND code below. removing data-attributes
        //    for pattern would be possible with minor modifications

        //    REF: // https://stackoverflow.com/questions/6177975/how-to-validate-date-with-format-mm-dd-yyyy-in-javascript

        // get birthday input group for this child
        let $birthInputGroups = parent.find(".js-birthday-input-field-wrap");

        let isValidDate = _.every($birthInputGroups, (birthInputGroup) => {
            const $birthInputGroup = $(birthInputGroup);
            let $inputMonth = $birthInputGroup.find(".js-month-input");
            let $inputDay = $birthInputGroup.find(".js-day-input");
            let $inputYear = $birthInputGroup.find(".js-year-input");

            // get user inputs
            let birthMonth = $inputMonth.val();
            let birthDay = $inputDay.val();
            let birthYear = $inputYear.val();

            // check the ranges of month and year
            // ** not valid date for years outside 1000-3000 or days outside 1-12
            if (birthYear < 1000 || birthYear > 3000 || birthMonth == 0 || birthMonth > 12) {
                return false;
            }

            // days in each month
            const numDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            // adjust for leap years
            if (birthYear % 400 == 0 || (birthYear % 100 != 0 && birthYear % 4 == 0)) {
                numDaysInMonth[1] = 29;
            }

            // MUST return something here
            // check the range of the day for given month
            // ** only valid if given birth day of month is from 1-[days in specific month]
            return birthDay > 0 && birthDay <= numDaysInMonth[birthMonth - 1];
        });

        if (!matchesRequiredPattern || !isValidDate) {
            parent.addClass("has-error has-danger");
            errorMessage.removeClass("is-display-none");
        } else {
            parent.removeClass("has-error has-danger");
            errorMessage.addClass("is-display-none");
        }
    }

    manageMonthSelect($monthSelect: any) {
        const apiURL = this.ui.form.data("api-url");
        const $optionSelected = $monthSelect.find("option:selected"); // get selected option
        const optionSelectedMonth = $optionSelected.val(); // get month name from option value

        // if selected MONTH option has been changed and is NOT empty
        // (aka doesn't have the `is-default` class)...
        if (!$optionSelected.hasClass("is-default")) {
            // ...give ALL`schedule a visit` selects `required` attribute
            // (for validator and submit button management)
            this.ui.scheduleVisitSelectsAll.attr("required", "required");
            this.triggerFormValidator();
        } else {
            // if selection is changed to default option (aka has `is-default` class),
            // none of them schedule visit selects should be required
            this.ui.scheduleVisitSelectsAll.removeAttr("required");
        }

        // re-trigger validator, since form requirements may have changed
        this.triggerFormValidator();

        // use name from selected month to access DAYS for
        // that month in JSON object via AJAX
        $.ajax({
            type: 'GET',
            url: apiURL,
            cache: false,
            data: { selectedMonth: optionSelectedMonth },
            success: (data) => {
                if (data.success) {
                    // clear existing options from day select
                    this.ui.scheduleVisitSelectDay.empty();
                    // get data
                    let optionArray = $.parseJSON(data.daysjson);
                    // ensure first option is "empty"
                    this.ui.scheduleVisitSelectDay.append('<option selected class= "is-default" >-- Day --</option>');
                    // populate all day options from data for selected month
                    $.each(optionArray, (index, obj) => {
                        this.ui.scheduleVisitSelectDay.append('<option value="' + obj.value + '">' + obj.text + '</option>');
                    });
                    // refresh the day selectpicker
                    this.ui.scheduleVisitSelectDay.selectpicker('refresh');
                }
            }
        });
    }

    triggerFormValidator() {
        this.ui.form.validator("update");
    }
}


// WEBPACK FOOTER //
// ./django/project/@static/@modules/find-a-center/controller.ts